import { useTheme } from "@/src/styles/theme-provider";
import { useTranslation } from "react-i18next";
import { Image, Text, View } from "react-native";

const CategoriesEmptyState = () => {
  const { t } = useTranslation();
  const { themeVars } = useTheme();

  return (
    <View className="flex-1 items-center justify-center gap-3 py-12">
      <Image
        source={require("@/src/assets/images/empty-state.png")}
        style={{ width: 120, height: 120 }}
        resizeMode="contain"
      />
      <Text
        className="text-sm text-center"
        style={{ color: themeVars["--color-slate-default"] as string }}
      >
        {t("LABEL_NO_CATEGORIES_DESC")}
      </Text>
    </View>
  );
};

export default CategoriesEmptyState;
